import { Result } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';

export default function CustomerData() {
  return (
    <Result
      icon={<DatabaseOutlined />}
      title="客户数据"
      subTitle="此功能正在开发中，敬请期待"
    />
  );
}
